import { useEffect, useMemo, useState } from "react";
const MEDIAS = {
  XS: "(max-width: 374px)",
  S: "(min-width: 375px) and (max-width: 767px)",
  M: "(min-width: 768px) and (max-width: 991px)",
  L: "(min-width: 992px) and (max-width: 1199px)",
  XL: "(min-width: 1200px)"
};
let matchMediaWatchInstances = {
  XS: void 0,
  S: void 0,
  M: void 0,
  L: void 0,
  XL: void 0,
  initialized: false
};
const registerMatchMedia = () => {
  matchMediaWatchInstances.XS = window.matchMedia(MEDIAS.XS);
  matchMediaWatchInstances.S = window.matchMedia(MEDIAS.S);
  matchMediaWatchInstances.M = window.matchMedia(MEDIAS.M);
  matchMediaWatchInstances.L = window.matchMedia(MEDIAS.L);
  matchMediaWatchInstances.XL = window.matchMedia(MEDIAS.XL);
  matchMediaWatchInstances.initialized = true;
};
const setupMatchListeners = (setCurrentMedia) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const xlListener = (event) => {
    if (event.matches) {
      setCurrentMedia("XL");
    }
  };
  const lListener = (event) => {
    if (event.matches) {
      setCurrentMedia("L");
    }
  };
  const mListener = (event) => {
    if (event.matches) {
      setCurrentMedia("M");
    }
  };
  const sListener = (event) => {
    if (event.matches) {
      setCurrentMedia("S");
    }
  };
  const xsListener = (event) => {
    if (event.matches) {
      setCurrentMedia("XS");
    }
  };
  if ((_a = matchMediaWatchInstances.XS) == null ? void 0 : _a.addEventListener) {
    (_b = matchMediaWatchInstances.XS) == null ? void 0 : _b.addEventListener("change", xsListener);
    (_c = matchMediaWatchInstances.S) == null ? void 0 : _c.addEventListener("change", sListener);
    (_d = matchMediaWatchInstances.M) == null ? void 0 : _d.addEventListener("change", mListener);
    (_e = matchMediaWatchInstances.L) == null ? void 0 : _e.addEventListener("change", lListener);
    (_f = matchMediaWatchInstances.XL) == null ? void 0 : _f.addEventListener("change", xlListener);
  } else {
    (_g = matchMediaWatchInstances.XS) == null ? void 0 : _g.addListener(xsListener);
    (_h = matchMediaWatchInstances.S) == null ? void 0 : _h.addListener(sListener);
    (_i = matchMediaWatchInstances.M) == null ? void 0 : _i.addListener(mListener);
    (_j = matchMediaWatchInstances.L) == null ? void 0 : _j.addListener(lListener);
    (_k = matchMediaWatchInstances.XL) == null ? void 0 : _k.addListener(xlListener);
  }
  return () => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2;
    if ((_a2 = matchMediaWatchInstances.XS) == null ? void 0 : _a2.addEventListener) {
      (_b2 = matchMediaWatchInstances.XS) == null ? void 0 : _b2.removeEventListener("change", xsListener);
      (_c2 = matchMediaWatchInstances.S) == null ? void 0 : _c2.removeEventListener("change", sListener);
      (_d2 = matchMediaWatchInstances.M) == null ? void 0 : _d2.removeEventListener("change", mListener);
      (_e2 = matchMediaWatchInstances.L) == null ? void 0 : _e2.removeEventListener("change", lListener);
      (_f2 = matchMediaWatchInstances.XL) == null ? void 0 : _f2.removeEventListener("change", xlListener);
    } else {
      (_g2 = matchMediaWatchInstances.XS) == null ? void 0 : _g2.removeListener(xsListener);
      (_h2 = matchMediaWatchInstances.S) == null ? void 0 : _h2.removeListener(sListener);
      (_i2 = matchMediaWatchInstances.M) == null ? void 0 : _i2.removeListener(mListener);
      (_j2 = matchMediaWatchInstances.L) == null ? void 0 : _j2.removeListener(lListener);
      (_k2 = matchMediaWatchInstances.XL) == null ? void 0 : _k2.removeListener(xlListener);
    }
    matchMediaWatchInstances = {
      XS: void 0,
      S: void 0,
      M: void 0,
      L: void 0,
      XL: void 0,
      initialized: false
    };
  };
};
const getClientInitialValue = (ssrViewPort) => {
  var _a, _b, _c, _d;
  if (typeof window === "undefined") {
    return ssrViewPort || "XS";
  }
  if (!matchMediaWatchInstances.initialized) {
    registerMatchMedia();
    if (ssrViewPort) {
      return ssrViewPort;
    }
  }
  if ((_a = matchMediaWatchInstances.XL) == null ? void 0 : _a.matches) {
    return "XL";
  }
  if ((_b = matchMediaWatchInstances.L) == null ? void 0 : _b.matches) {
    return "L";
  }
  if ((_c = matchMediaWatchInstances.M) == null ? void 0 : _c.matches) {
    return "M";
  }
  if ((_d = matchMediaWatchInstances.S) == null ? void 0 : _d.matches) {
    return "S";
  }
  return "XS";
};
const useMatchMedia = (ssrValue) => {
  const viewPort = ssrValue == null ? void 0 : ssrValue.viewPort;
  const initialValue = useMemo(() => getClientInitialValue(viewPort), [viewPort]);
  const [currentMedia, setCurrentMedia] = useState(initialValue);
  useEffect(() => {
    const value = getClientInitialValue();
    setCurrentMedia(value);
    return setupMatchListeners(setCurrentMedia);
  }, []);
  return currentMedia;
};
var useMatchMedia_default = useMatchMedia;
export {
  MEDIAS,
  useMatchMedia_default as default
};
